const SettingsIndexPage = (resolve) => {
  require.ensure(["./settings/index.vue"], () => {
    resolve(require("./settings/index.vue"))
  }, "admin_settings")
}

const UsersIndexPage = (resolve) => {
  require.ensure(["./users/index.vue"], () => {
    resolve(require("./users/index.vue"))
  }, "admin_users")
}

const UserFormPage = (resolve) => {
  require.ensure(["./users/form.vue"], () => {
    resolve(require("./users/form.vue"))
  }, "admin_users")
}

const UserGroupsIndexPage = (resolve) => {
  require.ensure(["./user-groups/index.vue"], () => {
    resolve(require("./user-groups/index.vue"))
  }, "admin_user_groups")
}

const UserGroupFormPage = (resolve) => {
  require.ensure(["./user-groups/form.vue"], () => {
    resolve(require("./user-groups/form.vue"))
  }, "admin_user_groups")
}

const NotesIndexPage = (resolve) => {
  require.ensure(["./notes/index.vue"], () => {
    resolve(require("./notes/index.vue"))
  }, "admin_notes")
}

const NoteFormPage = (resolve) => {
  require.ensure(["./notes/form.vue"], () => {
    resolve(require("./notes/form.vue"))
  }, "admin_notes")
}

export default (appRoutes) => {
  appRoutes.push({ path: "admin/settings", component: SettingsIndexPage })
  appRoutes.push({ path: "admin/users", component: UsersIndexPage })
  appRoutes.push({ path: "admin/users/:id", component: UserFormPage })
  appRoutes.push({ path: "admin/user-groups", component: UserGroupsIndexPage })
  appRoutes.push({ path: "admin/user-groups/:id", component: UserGroupFormPage })
  appRoutes.push({ path: "admin/notes", component: NotesIndexPage })
  appRoutes.push({ path: "admin/notes/:id", component: NoteFormPage })
}